<!-- Modal -->
<div class="modal-overlay" 
    [ngClass]="{
        'modal-overlay-default': this.getModalType() !== modalTypeE.guidedTour,
        'modal-overlay-guided-tour': this.getModalType() == modalTypeE.guidedTour
    }" 
    [hidden]="!getIsOpen()">
    <div class="custom-modal-container th-bg-white position-relative modal-size {{this.getStyleClass()}}"
            [ngClass]="{
                'custom-modal-container-guided-tour': this.getModalType() === modalTypeE.guidedTour,
                'custom-modal-overflow': this.getModalType() !== modalTypeE.guidedTour
            }" 
        [id]="this.getId()"
        [style.width]="this.getWidth()+'px'"
        [ngStyle]="{
            'top' : this.getModalType() === modalTypeE.guidedTour ? this.yAxis+'px': '0px',
            'left' : this.getModalType() === modalTypeE.guidedTour ? this.xAxis+'px': '0px'
        }">

        <!-- close button -->
        <div class="close-button-container" 
             *ngIf="this.getCanBeClosed()"
             (click)="this.closeDialog()">
             <img [src]="this.closeIconPath">
        </div>

        <!-- tag -->
        <div *ngIf="this.getTagText() && this.getTagText().length > 0" 
            [class]="this.getTagColorClass() + ' tag-container' + ' user-select-none p-3'">
            <span class="bs-paragraph th-text-white">{{this.getTagText()}}</span>
        </div>

        <!-- guided tour arrow -->
        <div class="triangle-pointer" [ngClass]="{
            'triangle-pointer-left': this.isGuidedArrowLeft,
            'triangle-pointer-right': !this.isGuidedArrowLeft
        }" *ngIf="this.getModalType() === modalTypeE.guidedTour"></div>

        <!-- header -->
        <div [ngClass]="{
            'modal-header-container': this.getModalIconType() !== '' && getModalType() !== '',
            'modal-header-container-left': this.getModalIconType() === '' && getModalType() === ''
            }">

            <div [ngClass]="{
                'modal-header-content-left': this.getModalIconType() === '',
                'modal-header-content-center': this.getModalIconType() !== ''
                }">
                <!-- header with just text -->
                <div *ngIf="this.getModalIconType() === ''">
                    <div class="d-flex flex-column">
                        <span class="bs-h1 th-text-main header-title-container">{{this.getTitle()}}</span>
                        <span class="bs-paragraph th-text-gray-paragraphs" [innerHTML]="this.getDescription()"></span>
                    </div>
                </div>
    
                <!-- header with icon -->
                <div *ngIf="this.getModalIconType() !== ''" class="d-flex flex-column align-items-center">
                    <object [data]="this.getMessageIcon() | safeUrl"
                            type="image/svg+xml"
                            [width]="this.iconWidth"
                            [height]="this.iconHeight">
                    </object>
                    <div class="d-flex flex-column align-items-center">
                        <span class="bs-h1 th-text-main header-title-container" [ngClass]="{
                            'text-center' : this.getModalIconType() !== ''
                        }">{{this.getTitle()}}</span>
                        <span class="bs-paragraph th-text-gray-paragraphs text-center" [innerHTML]="this.getDescription()"></span>
                    </div>
                </div>
            </div>

        </div>

        <!-- content -->
        <div class="modal-body-container" *ngIf="this.getMetaData().models.length > 0">
            <ng-container #target></ng-container>
        </div>

        <!-- footer -->
        <div *ngIf="this.getModalType() !== ''" [ngClass]="{
            'mb-0 mt-0': this.getHasFooterSpacing() === false,
            'modal-footer-container': this.getHasFooterSpacing() || this.getHasFooterSpacing() == null || this.getHasFooterSpacing() == undefined
        }">

            <!-- single button -->
            <div *ngIf="getModalType() !== modalTypeE.confirmation &&
                        getModalType() !== modalTypeE.guidedTour"
                 class="w-100">
                <ng-container #actionButtonContainer></ng-container>
            </div>

            <!-- two buttons -->
            <div *ngIf="getModalType() === modalTypeE.confirmation || 
                        getModalType() === modalTypeE.guidedTour"
                 class="row">
                <div class="col" *ngIf="getModalType() !== modalTypeE.guidedTour">
                    <ng-container #defaultButtonContainer></ng-container>
                </div>
                <div class="col d-flex align-items-center" *ngIf="getModalType() === modalTypeE.guidedTour">
                    <span class="bs-text-roboto-alert th-text-alert cancel-text-button" (click)="executeCancelAction()">
                        {{this.getCancelButtonText()}}
                    </span>
                </div>
                <div class="col">
                    <ng-container #actionButtonContainer></ng-container>
                </div>
            </div>

        </div>
    </div>
</div>